// Grouped, honest skills — kept consistent with the CV and LinkedIn.
const skills = [
  {
    group: "Languages",
    items: ["JavaScript", "TypeScript", "Python", "Java", "SQL"],
  },
  {
    group: "Frontend",
    items: ["React", "Astro", "Tailwind CSS", "HTML", "CSS"],
  },
  {
    group: "Backend",
    items: ["Node.js", "Express", "REST APIs", "headless CMS"],
  },
  {
    group: "Databases",
    items: ["MongoDB", "PostgreSQL", "MySQL"],
  },
  {
    group: "Tools",
    items: ["Git", "GitHub", "Docker", "AI-assisted development"],
  },
];

export default skills;
